"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBalance = exports.validateBalance = exports.balanceToDynamoDBDocClientObject = exports.dynamodbRecordToBalance = void 0;
const balance_1 = require("./balance");
function dynamodbRecordToBalance(record) {
    const balance = new balance_1.Balance();
    if (record.dynamodb) {
        const dynamodb = record.dynamodb;
        const newImage = dynamodb.NewImage;
        if (newImage) {
            balance.eventDatetime = (newImage.EventDatetime) ? newImage.EventDatetime.S || '' : balance.eventDatetime;
            balance.balanceKey = (newImage.BalanceKey) ? newImage.BalanceKey.S || '' : balance.balanceKey;
            balance.balanceDate = (newImage.BalanceDate) ? newImage.BalanceDate.S || '' : balance.balanceDate;
            balance.type = (newImage.Type) ? newImage.Type.S || '' : balance.type;
            balance.currency = (newImage.Currency) ? newImage.Currency.S || '' : balance.currency;
            balance.identifier = (newImage.Identifier) ? newImage.Identifier.S || '' : balance.identifier;
            balance.secondaryIdentifier = (newImage.SecondaryIdentifier) ? newImage.SecondaryIdentifier.S || '' : balance.secondaryIdentifier;
            balance.amount = (newImage.Amount) ? parseFloat(newImage.Amount.N || '0') : balance.amount;
            balance.account = (newImage.Account) ? newImage.Account.S || '' : balance.account;
        }
    }
    return balance;
}
exports.dynamodbRecordToBalance = dynamodbRecordToBalance;
function balanceToDynamoDBDocClientObject(balance) {
    const items = {};
    const balanceAny = balance;
    for (let key of Object.keys(balanceAny)) {
        const dbKey = key.charAt(0).toUpperCase() + key.substring(1);
        const value = balanceAny[key];
        if (typeof value === 'boolean') {
            items[dbKey] = String(balanceAny[key]);
        }
        else if (typeof value === 'number') {
            items[dbKey] = balanceAny[key];
        }
        else if (typeof value === 'string') {
            if (value.length > 0) {
                // Let's not fill up DynamoDB with empty strings...
                items[dbKey] = balanceAny[key];
            }
        }
        else {
            console.log("Other type:" + key + " value:" + value);
        }
    }
    ;
    return items;
}
exports.balanceToDynamoDBDocClientObject = balanceToDynamoDBDocClientObject;
function validateBalance(balance) {
    const dateRegex = /^\d{4}\-(0?[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
    const datetimeRegex = /^\d{4}\-(0?[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])[\sT]([012])([0-9]):([012345])([0-9]).*$/;
    if (!balance.eventDatetime) {
        return 'eventDatetime is required';
    }
    if (typeof balance.eventDatetime !== 'undefined' && !(datetimeRegex.test(balance.eventDatetime))) {
        return 'eventDatetime must be formatted starting with YYYY-MM-DD HH:mm:SS';
    }
    if (!balance.balanceKey) {
        return 'balanceKey is required';
    }
    if (!balance.balanceDate) {
        return 'balanceDate is required';
    }
    if (typeof balance.balanceDate !== 'undefined' && !(dateRegex.test(balance.balanceDate))) {
        return 'balanceDate must be formatted YYYY-MM-DD';
    }
    if (!balance.type) {
        return 'type is required';
    }
    if (!balance.currency) {
        return 'currency is required';
    }
    if (!balance.amount && balance.amount !== 0.0) {
        return 'amount is required';
    }
    if (typeof balance.amount !== 'undefined' && typeof balance.amount !== 'number') {
        return 'amount must be a number';
    }
    return true;
}
exports.validateBalance = validateBalance;
function parseBalance(balance) {
    if (balance['amount']) {
        balance['amount'] = parseFloat(balance['amount']);
    }
    return balance;
}
exports.parseBalance = parseBalance;
//# sourceMappingURL=balance-converter.js.map